document.addEventListener('DOMContentLoaded', async()=>{
        
	// const carouselContainer = document.querySelector('.container__carousel--cart-page ')
    
	// // Si existe solo un item en cart => product recomendations
	// if(cartItems.item_count == '1'){

  	// 	// Tengo que validar que existan los line_items
	// 	const productID = cartItems.product_id
	// 	const template = await getRecomendationProducts(productID)
    //     setTimeout(() => {
    //         document.querySelector('.product-recommendations-placeholder').remove()
    //         document.querySelector('.container__carousel--cart-page .page-width').remove()
    //         let recomendationCarousel = document.querySelector('.grid--uniform')
    //         recomendationCarousel.removeAttribute('class')
    //         recomendationCarousel.setAttribute('class', 'recomentation__carousel')
    //         slickSlideRecomentadion()
    //     }, 50);
        
      
    //     // Validar que exista producto recomendado 
    //     if(template == ''){
    //   		carouselContainer.remove();
    //       	return;
    //     }
      
    //     // Actualizo template
	// 	carouselContainer.innerHTML = template;

	// }

	slickSlideCollection();

})

async function getRecomendationProducts(productID){
	
  try{
  	const request = await fetch(window.Shopify.routes.root + `recommendations/products?product_id=${productID}&limit=4&section_id=product-recommendations`)
  	return await request.text()
  }catch(error) {
  	console.error(error)
    return '';
  }
 
}

function flktySlide(){
	var featureSlide = document.querySelector('.container__carousel--cart-page');
    var flktySlide = new Flickity(featureSlide, {
    // options
        contain: true,
        pageDots: false,
        groupCells: 2
    });
}

 function slickSlideCollection() {
    $('.container__carousel--cart-page').slick({
        dots: true, 
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        prevArrow: `<button data-id="prevArrowTemplate" class="slick-prev slick-arrow " aria-label="Anterior" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="6.25" height="10" viewBox="0 0 6.25 10">
                <path id="arrow-down" d="M7.25,10.5,11,14.25l3.75-3.75L16,11.75l-5,5-5-5Z" transform="translate(16.75 -6) rotate(90)" fill="#bcb9b6" fill-rule="evenodd"/>
            </svg>              
        </button>`,
        nextArrow: `<button data-id="nextArrowTemplate" class="slick-next slick-arrow " aria-label="Siguiente" type="button" style="">
                <svg xmlns="http://www.w3.org/2000/svg" width="6.25" height="10" viewBox="0 0 6.25 10" style="transform: rotate(-180deg);">
                    <path id="arrow-down" d="M7.25,10.5,11,14.25l3.75-3.75L16,11.75l-5,5-5-5Z" transform="translate(16.75 -6) rotate(90)" fill="#bcb9b6" fill-rule="evenodd"/>
                </svg>          
            </button>`,
        responsive: [
            {
                breakpoint: 768,
                settings: { 
                    dots: true,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
        
    });  
 }
 function slickSlideRecomentadion() {
    $('.recomentation__carousel').slick({
        dots: true,
        infinite: false,
        slidesToShow:2,
        slidesToScroll: 1,
        prevArrow: `<button data-id="prevArrowTemplate" class="slick-prev slick-arrow " aria-label="Anterior" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="6.25" height="10" viewBox="0 0 6.25 10">
                <path id="arrow-down" d="M7.25,10.5,11,14.25l3.75-3.75L16,11.75l-5,5-5-5Z" transform="translate(16.75 -6) rotate(90)" fill="#bcb9b6" fill-rule="evenodd"/>
            </svg>              
        </button>`,
        nextArrow: `<button data-id="nextArrowTemplate" class="slick-next slick-arrow " aria-label="Siguiente" type="button" style="">
                <svg xmlns="http://www.w3.org/2000/svg" width="6.25" height="10" viewBox="0 0 6.25 10" style="transform: rotate(-180deg);">
                    <path id="arrow-down" d="M7.25,10.5,11,14.25l3.75-3.75L16,11.75l-5,5-5-5Z" transform="translate(16.75 -6) rotate(90)" fill="#bcb9b6" fill-rule="evenodd"/>
                </svg>          
            </button>`,
        responsive: [
            {
                breakpoint: 768,
                settings: { 
                    dots: true,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });  
 }

